module.exports = __webpack_public_path__ + "img/logo.125a3d3e.png";